$(function () {
    if ($(".js-submit-form").length > 0) {
        const submitForm = $(".js-submit-form");

        submitForm.submit(function (event) {
            const form = $(this);
            const btnSubmit = form.find(".js-btn-submit");
            const loadingIcon = form.find(".js-loading-icon");
            const formUrl = form.attr("action");
            const formId = form.attr("id");
            const formData = new FormData($(this)[0]);

            form.find(".js-form-error").html("");
            form.find(".error").removeClass("error");
            btnSubmit.addClass("d-none");
            loadingIcon.removeClass("d-none");

            axios({
                method: "post",
                url: formUrl,
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then(function (response) {
                let data = response.data;

                if (data.status == "error") {
                    if (!data.messages) {
                        return;
                    }

                    let messages = data.messages;
                    let num = 0;

                    for (const key in messages) {
                        const element = messages[key];
                        num = num + 1;

                        if (num == 1) {
                            form.find(`#${key}`).focus();
                        }

                        form.find(`#error_${key}`).html(
                            `<div class="-form-error-text">${element[0]}</div>`
                        );

                        form.find(`#${key}`).addClass("error");
                    }
                } else {
                    if (form.attr("data-modal")) {
                        let dataModal = form.attr("data-modal");
                        let popup = new bootstrap.Modal(
                            document.getElementById(`${dataModal}`),
                            {
                                keyboard: false,
                            }
                        );
                        popup.show();
                    }

                    if (data.access_token) {
                        localStorage.setItem("access_token", data.access_token);
                    }

                    // if (formId == "loginForm") {
                    //     if (form.attr("data-vista")) {
                    //         window.top.location.href = form.attr("data-vista");

                    //         return;
                    //     }

                    //     window.top.location.reload();
                    //     return;
                    // }

                    if (data.url) {
                        window.top.location.href = data.url;
                    }

                    if (data.redirect_to) {
                        window.location.href = data.redirect_to;
                    }

                    // submitForm[0].reset();
                }

                btnSubmit.removeClass("d-none");
                loadingIcon.addClass("d-none");
            });

            event.preventDefault();
        });
    }
});
